export function isUrl(string: string) {
  try {
    const url = new URL(string)
    return !!url
  } catch (err) {
    console.log('Invalid URL!')
    return false
  }
}
